import { useData } from "data/data-provider";
import { previewDesign } from "lib/devPreview";

/**
 * 1NOW-11176: is this site drawn in Design B?
 *
 * The two car pages are shared by Designs A and B, so everything that only Design B
 * changes asks here first. It is the rule App uses to pick the router: a dev preview
 * (`?design=`) first, then the tenant's own `default_template`. Design B is "design2".
 */
export const useIsDesignB = (): boolean => {
  const { ourCompany } = useData();
  return (previewDesign() || ourCompany?.default_template) === "design2";
};
